import React from "react";
import { Link } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import logo from "../Assets/Img/logo.png";
import logoServizi from "../Assets/Img/logo_icona.png";

function Footer(props) {
  return (
    <footer className="it-footer">
      <div className="it-footer-main">
        <div className="container">
          <section>
            <div className="row clearfix">
              <div className="col-sm-12">
                <div className="it-brand-wrapper d-flex">
                  <a
                    href="https://www.comune.bari.it/attuazione-misure-pnrr/attuazione-misure-pnrr"
                    title="Logo Unione Europea"
                    aria-label="Logo Unione Europea"
                  >
                    <img
                      className="img-fluid mr-2"
                      width="200"
                      height="62"
                      alt="Logo Unione Europea"
                      src="https://www.comune.bari.it/o/portale-istituzionale-theme/images/project/logo-ue-nextgeneration.webp"
                    />
                  </a>
                  <a
                    href="https://www.comune.bari.it"
                    title="Comune di Bari"
                    aria-label="Comune di Bari"
                  >
                    <a href="/">
                      <img
                        alt="logo Comune di Bari"
                        height="50"
                        width="50"
                        src={logo}
                      />
                    </a>
                    <div className="it-brand-text">
                      <h2 className="no_toc">Comune di Bari</h2>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section>
            <div
              className="portlet-boundary portlet-boundary_com_liferay_site_navigation_menu_web_portlet_SiteNavigationMenuPortlet_ portlet-static portlet-static-end portlet-barebone portlet-navigation"
              id="p_p_id_com_liferay_site_navigation_menu_web_portlet_SiteNavigationMenuPortlet_INSTANCE_nav_footer_"
            >
              <span id="p_com_liferay_site_navigation_menu_web_portlet_SiteNavigationMenuPortlet_INSTANCE_nav_footer" />

              <section
                className="portlet"
                id="portlet_com_liferay_site_navigation_menu_web_portlet_SiteNavigationMenuPortlet_INSTANCE_nav_footer"
              >
                <div className="portlet-content">
                  <div className="portlet-content-container">
                    <div className="portlet-body">
                      <div
                        className="row"
                        id="navbar_com_liferay_site_navigation_menu_web_portlet_SiteNavigationMenuPortlet_INSTANCE_nav_footer"
                      >
                        {/* Amministrazione */}
                        <div className="col-lg-3 col-md-3 col-sm-6 pb-2">
                          <div
                            style={{
                              fontSize: "0.88889rem",
                              lineHeight: "1.428",
                              fontWeight: 600,
                              letterSpacing: "normal",
                              marginBottom: "0.5rem",
                              marginTop: 0,
                              textTransform: "uppercase",
                            }}
                          >
                            <a
                              href="https://www.comune.bari.it/amministrazione"
                              title="Vai alla pagina: Amministrazione"
                            >
                              <span>Amministrazione</span>
                            </a>
                          </div>

                          <div className="link-list-wrapper">
                            <ul className="footer-list link-list clearfix">
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/organi-di-governo"
                                  title="Vai alla pagina: Organi di governo"
                                >
                                  Organi di governo
                                </a>
                              </li>
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/aree-amministrative"
                                  title="Vai alla pagina: Aree amministrative"
                                >
                                  Aree amministrative
                                </a>
                              </li>
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/uffici"
                                  title="Vai alla pagina: Uffici"
                                >
                                  Uffici
                                </a>
                              </li>
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/enti-e-fondazioni"
                                  title="Vai alla pagina: Enti e fondazioni"
                                >
                                  Enti e fondazioni
                                </a>
                              </li>
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/documenti-e-dati"
                                  title="Vai alla pagina: Documenti e dati"
                                >
                                  Documenti e dati
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>

                        {/* Novità */}
                        <div className="col-lg-3 col-md-3 col-sm-6 pb-2">
                          <div
                            style={{
                              fontSize: "0.88889rem",
                              lineHeight: "1.428",
                              fontWeight: 600,
                              letterSpacing: "normal",
                              marginBottom: "0.5rem",
                              marginTop: 0,
                              textTransform: "uppercase",
                            }}
                          >
                            <a
                              href="https://www.comune.bari.it/novita"
                              title="Vai alla pagina: Novità"
                            >
                              <span>Novità</span>
                            </a>
                          </div>

                          <div className="link-list-wrapper">
                            <ul className="footer-list link-list clearfix">
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/notizie"
                                  title="Vai alla pagina: Notizie"
                                >
                                  Notizie
                                </a>
                              </li>
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/comunicati"
                                  title="Vai alla pagina: Comunicati"
                                >
                                  Comunicati
                                </a>
                              </li>
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/avvisi"
                                  title="Vai alla pagina: Avvisi"
                                >
                                  Avvisi
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>

                        {/* Servizi */}
                        <div className="col-lg-3 col-md-3 col-sm-6 pb-2">
                          <div
                            style={{
                              fontSize: "0.88889rem",
                              lineHeight: "1.428",
                              fontWeight: 600,
                              letterSpacing: "normal",
                              marginBottom: "0.5rem",
                              marginTop: 0,
                              textTransform: "uppercase",
                            }}
                          >
                            <a
                              href="https://www.comune.bari.it/servizi"
                              title="Vai alla pagina: Servizi"
                            >
                              <span>Servizi</span>
                            </a>
                          </div>
                        </div>

                        {/* Vivere Bari */}
                        <div className="col-lg-3 col-md-3 col-sm-6 pb-2">
                          <div
                            style={{
                              fontSize: "0.88889rem",
                              lineHeight: "1.428",
                              fontWeight: 600,
                              letterSpacing: "normal",
                              marginBottom: "0.5rem",
                              marginTop: 0,
                              textTransform: "uppercase",
                            }}
                          >
                            <a
                              href="https://www.comune.bari.it/vivere-bari"
                              title="Vai alla pagina: Vivere Bari"
                            >
                              <span>Vivere Bari</span>
                            </a>
                          </div>

                          <div className="link-list-wrapper">
                            <ul className="footer-list link-list clearfix">
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/luoghi"
                                  title="Vai alla pagina: Luoghi"
                                >
                                  Luoghi
                                </a>
                              </li>
                              <li>
                                <a
                                  className="list-item"
                                  href="https://www.comune.bari.it/eventi"
                                  title="Vai alla pagina: Eventi"
                                >
                                  Eventi
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </section>
         
<section className="py-4 border-white border-top">
  <div className="row">
    <div className="col-lg col-md pb-2">

      <div
        style={{
          fontSize: "0.88889rem",
          lineHeight: "1.428",
          fontWeight: 600,
          letterSpacing: "normal",
          marginBottom: "0.5rem",
          marginTop: 0,
          textTransform: "uppercase",
        }}
      >
        <span>Contatti</span>
      </div>

      <div>
        <p>
          <strong>Comune di Bari</strong>
        </p>

        <p>
          Palazzo di Città | Corso Vittorio Emanuele II, 84 | 70122 Bari | Italy
          <br />
          URP - Ufficio Relazioni con il Pubblico:&nbsp;
          <a href="tel:0805772390">080/5772390</a>&nbsp;-&nbsp;
          <a href="tel:800018291">800/018291</a>&nbsp;(solo da telefono fisso)
          <br />
          Centralino:&nbsp;
          <a href="tel:+390805771111">+39 080 577 1111</a>
          <br />
          CF: 80015010723 - P.IVA: 00268080728
        </p>

        <p>
          Per l'elenco delle PEC:&nbsp;
          <a
            href="https://indicepa.gov.it/ipa-portale/consultazione/domicilio-digitale/ricerca-domicili-digitali-ente/scheda-area-organizzativa-omogenea/A2C2844/scheda-ente/4063"
            target="_blank"
            rel="noreferrer"
          >
            Indice delle Pubbliche Amministrazioni
          </a>
        </p>
      </div>

      <div className="link-list-wrapper">
        <ul className="footer-list link-list clearfix"></ul>
      </div>
    </div>

    <div className="col-lg col-md pb-2">
      <div
        style={{
          fontSize: "0.88889rem",
          lineHeight: "1.428",
          fontWeight: 600,
          letterSpacing: "normal",
          marginBottom: "0.5rem",
          marginTop: 0,
          textTransform: "uppercase",
        }}
      >
        <span>Seguici su</span>
      </div>

      <ul className="list-inline text-left social">
        <li className="list-inline-item">
          <a
            className="p-2 text-white"
            href="https://www.facebook.com/comunedibari"
            target="_blank"
            rel="noreferrer"
          >
            <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-facebook`} />
                    </svg>
            <span className="sr-only">Facebook</span>
          </a>
        </li>

        <li className="list-inline-item">
          <a
            className="p-2 text-white"
            href="https://x.com/ComunediBari"
            target="_blank"
            rel="noreferrer"
          >
                        <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-twitter`} />
                    </svg>
            <span className="sr-only">Twitter</span>
          </a>
        </li>

        <li className="list-inline-item">
          <a
            className="p-2 text-white"
            href="https://www.youtube.com/comunedibari"
            target="_blank"
            rel="noreferrer"
          >
                        <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-youtube`} />
                    </svg>


            <span className="sr-only">Youtube</span>
          </a>
        </li>

        <li className="list-inline-item">
          <a
            className="p-2 text-white"
            href="https://www.instagram.com/comune_bari"
            target="_blank"
            rel="noreferrer"
          >

                        <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-instagram`} />
                    </svg>

            <span className="sr-only">Instagram</span>
          </a>
        </li>

        <li className="list-inline-item">
          <a
            className="p-2 text-white"
            href="https://telegram.me/bariallerta"
            target="_blank"
            rel="noreferrer"
          >
                        <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-telegram`} />
                    </svg>


            <span className="sr-only">Telegram</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</section>
   </div>
          <hr/>

<div className="it-footer-small-prints clearfix">
  <div className="container">
    <h3 className="sr-only">Link utili</h3>

    <ul className="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row flex-md-wrap">
      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/informativa-privacy"
          data-element="privacy-policy-link"
          title="Vai alla pagina: Informativa privacy"
        >
          Informativa privacy
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://form.agid.gov.it/c_a662/portale_comunale/dichiarazione"
          data-element="accessibility-link"
          title="Vai alla pagina: Dichiarazione di accessibilità"
        >
          Dichiarazione di accessibilità
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/note-legali"
          data-element="legal-notes"
          title="Vai alla pagina: Note legali"
        >
          Note legali
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/domande-frequenti"
          data-element="faq"
          title="Vai alla pagina: Domande frequenti"
        >
          Domande frequenti
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/richiesta-di-assistenza"
          data-element="faq"
          title="Vai alla pagina: Richiesta di assistenza"
        >
          Richiesta di assistenza
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/segnalazioni"
          data-element="report-inefficiency"
          title="Vai alla pagina: Segnalazione disservizio"
        >
          Segnalazione disservizio
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/prenotazione-appuntamento"
          data-element="appointment-booking"
          title="Vai alla pagina: Prenotazione appuntamento"
        >
          Prenotazione appuntamento
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/archivio"
          data-element="archivio"
          title="Vai alla pagina: Archivio"
        >
          Archivio
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="#"
          title="Vai alla pagina: Area riservata"
        >
          Area riservata
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://dati.comune.bari.it/"
          target="_blank"
          rel="noreferrer"
          title="Vai alla pagina: Portale opendata"
        >
          Portale opendata
        </a>
      </li>

      <li className="list-inline-item pl-0">
        <a
          href="https://www.comune.bari.it/attuazione-misure-pnrr"
          title="Vai alla pagina: Attuazione Misure PNRR"
        >
          Attuazione Misure PNRR
        </a>
      </li>
    </ul>
  </div>
</div>



     
      </div>
    </footer>
  );
}

export default Footer;
export const MemoizedFooter = React.memo(Footer);
